export default {
  title: "Service professionnel",
  useNow: "Utiliser maintenant",
  faq1q: "Q : Qu'est-ce qu'un code d'activation ?",
  faq1a: "R : Code aléatoire permettant d'activer les services logiciels pour une durée définie.",
  faq2q: "Q : Comment obtenir un code ?",
  faq2a: "R : Contactez le support après achat.",
  faq3q: "Q : Comment l'utiliser ?",
  faq3a: "R : Saisissez le code sur cette page. Chaque code est utilisable une seule fois.",
  faq4q: "Q : Quelle est la validité ?",
  faq4a: "R : 365 jours à compter de la génération du code.",
  answerPrefix: "R : ",
};
